import { useState } from "react";
import { NavLink } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import { AppBar, Toolbar, IconButton } from "@mui/material";
import { useAuth } from "../../hooks/useAuth";
import { LOGIN } from "../../constants/routes";
import ProfileMenu from "./ProfileMenu/ProfileMenu";
import Menu from "./Menu/Menu";
import "./navbar.scss";

const Navbar = () => {
  const auth = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div>
      <AppBar position="fixed" elevation={0} className="nav-bar">
        <Toolbar className="tool-bar">
          <div className="menu-icon">
            <IconButton
              edge="start"
              color="inherit"
              aria-label="menu"
              onClick={() => setMenuOpen(!menuOpen)}
              size="large"
            >
              {menuOpen ? <CloseIcon /> : <MenuIcon />}
            </IconButton>
          </div>
          {auth.user ? (
            <ProfileMenu user={auth.user} />
          ) : (
            <div>
              <NavLink
                activeClassName="current-page"
                className="link-label"
                exact
                to={LOGIN}
              >
                Sign in
              </NavLink>
            </div>
          )}
        </Toolbar>
        <Menu user={auth.user} isOpen={menuOpen} setIsOpen={setMenuOpen} />
      </AppBar>
      <Toolbar />
    </div>
  );
};

export default Navbar;
